type FormatOptions = {
  formatFrom?: number;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  minimumSignificantDigits?: number;
  maximumSignificantDigits?: number;
}

/**
 * Format large numbers to smaller string
 * @param number to format
 * @param options object with following options:
 * @param formatFrom only format numbers that are bigger than this value
 * @param minimumFractionDigits min amount of fractions digits (after the dot). Default is 0
 * @param maximumFractionDigits max amount of fractions digits (after the dot). Default is 1
 * @param minimumSignificantDigits min amount of digits before the dot. Default is 1
 * @param maximumSignificantDigits max amount of digits before the dot. Default is 21
 * @returns formatted string
 * @example `150000` => `150K`
 * @example `1500000` => `1.5M`
 */
export const formatLargeNumber = (number: number,
  options = {
    formatFrom: 0,
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 21,
  } as FormatOptions,
): string => {
  if (options.formatFrom && options.formatFrom >= number) {
    return String(number);
  }
  return Intl.NumberFormat('en', {
    notation: 'compact',
    minimumFractionDigits: options.minimumFractionDigits,
    maximumFractionDigits: options.maximumFractionDigits,
    minimumSignificantDigits: options.minimumSignificantDigits,
    maximumSignificantDigits: options.maximumSignificantDigits,
  }).format(number);
};
